module.exports = __webpack_public_path__ + "img/43_54.e5ec2660.png";